module.exports = __webpack_public_path__ + "static/media/cargo.dab5ff72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/cargo.png
// module id = 572
// module chunks = 0